import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/**
 * 自定义的消息数目
 * 待接入
 */
import { debounce } from 'lodash';
export default {
  namespaced: true,
  state: {
    // 信息
    message: 0,
    //未读消息
    unreadCount: 0,
    //会话列表
    conversationList: [],
    //是否登录
    isImLogin: false,
    //是否显示客服窗口
    isImShow: false,
    //客户id
    isImFormId: ''
  },
  getters: {
    /**
     * @description 返回现存 log (all) 的条数
     * @param {*} state vuex state
     */
    length: function length(state) {
      return state.message;
    },
    unreadCount: function unreadCount(state) {
      return state.unreadCount;
    },
    conversationList: function conversationList(state) {
      return state.conversationList;
    },
    isImLogin: function isImLogin(state) {
      return state.isImLogin;
    },
    isImShow: function isImShow(state) {
      return state.isImShow;
    },
    isImFormId: function isImFormId(state) {
      return state.isImFormId;
    }
  },
  mutations: {
    tximCount: function tximCount(state, unreadCount) {
      state.unreadCount = unreadCount;
    },
    isImLogin: function isImLogin(state, _isImLogin) {
      state.isImLogin = _isImLogin;
    },
    isImShow: function isImShow(state, _isImShow) {
      state.isImShow = _isImShow;
    },
    isImFormId: function isImFormId(state, _isImFormId) {
      state.isImFormId = _isImFormId;
    }
  },
  actions: {
    load: function load(_ref) {
      var state = _ref.state;
      return new Promise(function (resolve) {
        // store 赋值
        state.list = [];
        resolve();
      });
    },
    asyncMessage: function asyncMessage(_ref2, n) {
      var state = _ref2.state;
      return new Promise(function (resolve) {
        // store 赋值
        state.message = n;
        resolve();
      });
    },
    tximConversationList: function tximConversationList(_ref3, conversationList) {
      var state = _ref3.state,
          commit = _ref3.commit;
      return new Promise(function (resolve) {
        state.conversationList = conversationList.filter(function (x) {
          return x.conversationID.indexOf('C2Ca_') === -1;
        });
        var unreadCount = state.conversationList.reduce(function (pre, cur) {
          return pre + cur.unreadCount;
        }, 0);
        commit('tximCount', unreadCount); // store 赋值

        resolve();
      });
    },
    isImShow: function isImShow(_ref4, bool) {
      var state = _ref4.state,
          commit = _ref4.commit;
      return new Promise(function (resolve, reject) {
        if (state.isImLogin) {
          // store 赋值
          commit('isImShow', bool);
          resolve();
        } else {
          if (state.isImShow) {
            commit('isImShow', false);
            alert('您当前处于离线状态,请重新登录');
          }

          reject();
        }
      });
    },
    isImLogin: function isImLogin(_ref5, bool) {
      var state = _ref5.state,
          commit = _ref5.commit;
      return new Promise(function (resolve) {
        // store 赋值
        commit('isImLogin', bool);
        resolve();
      });
    },
    isImFormId: function isImFormId(_ref6, id) {
      var state = _ref6.state,
          commit = _ref6.commit,
          dispatch = _ref6.dispatch;
      return new Promise( /*#__PURE__*/function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!state.isImShow) {
                    _context.next = 5;
                    break;
                  }

                  _context.next = 3;
                  return dispatch('isImShow', false);

                case 3:
                  _context.next = 5;
                  return YL.sleep(1);

                case 5:
                  commit('isImFormId', id);
                  _context.next = 8;
                  return dispatch('isImShow', true);

                case 8:
                  resolve();

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref7.apply(this, arguments);
        };
      }());
    }
  }
};